import { useEffect } from 'react'

// Set to display warnings only once per component
const _uniqWarns = new Set()

/**
 * @param componentName name of the component
 * @param message optional message
 */
const useDeprecatedComponent = (componentName: string, message: string) => {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      if (!_uniqWarns.has(componentName)) {
        let deprecationMessage = `[AIRBUS-DS] ${componentName} is deprecated.`
        if (message) {
          deprecationMessage += ` ${message}`
        }
        _uniqWarns.add(componentName)
        console.warn(deprecationMessage)
      }
    }

    return () => {}
  }, [componentName, message])
}

export default useDeprecatedComponent
